import { LinkIcon } from "@heroicons/react/outline";
import { useState } from "react";
import { useParams } from "react-router-dom";

import DatasetGroup from "./DatasetGroup";
import PipelineGroup from "./PipelineGroup";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface RelatedContentDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const RelatedContentDialog = ({
  open: controlledOpen,
  onOpenChange,
}: RelatedContentDialogProps) => {
  const { promptId } = useParams();
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const open = controlledOpen ?? uncontrolledOpen;
  const setOpen = onOpenChange ?? setUncontrolledOpen;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {controlledOpen === undefined && (
        <DialogTrigger asChild>
          <Button size="sm" variant="outline" onClick={() => setOpen(true)}>
            <LinkIcon className="mr-2 h-4 w-4" /> Datasets & Evaluations
          </Button>
        </DialogTrigger>
      )}

      <DialogContent className="max-h-[80vh] max-w-3xl overflow-hidden">
        <DialogHeader>
          <DialogTitle>Datasets & Evaluations</DialogTitle>
        </DialogHeader>
        <div
          className="flex flex-col gap-y-2 overflow-y-auto pr-2"
          style={{ maxHeight: "calc(80vh - 80px)" }}
        >
          <PipelineGroup promptId={Number(promptId)} />
          <hr className="my-4" />
          <DatasetGroup promptId={Number(promptId)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RelatedContentDialog;
